import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledLabel = styled(Typography)(({ theme }) => ({ paddingLeft: theme.spacing(1), fontSize: '1.1em' }));
